import { get, isString } from "lodash";
import { fn } from "overridable-fn";
import { ZodError, z } from "zod/v4";
export const formatErrorMessage = (
// biome-ignore lint/suspicious/noExplicitAny: Needed for generic handling
e, defaultMessage = "Something went wrong") => {
    if (e instanceof ZodError) {
        return z.prettifyError(e);
    }
    const msg = e?.message;
    if (typeof msg === "string" && msg.trim()) {
        if (e.cause)
            return `${msg}: ${formatErrorMessage(e.cause)}`;
        return msg;
    }
    return defaultMessage;
};
// biome-ignore lint/suspicious/noExplicitAny: Needs to handle arbitrary errors
export const reportError = fn((e, ctx) => {
    console.error(e, ctx);
});
export const getErrCode = (e) => {
    const code = get(e, "code");
    if (isString(code))
        return code;
    return null;
};
export const silence = (e) => {
    if (typeof e === "object") {
        // biome-ignore lint/suspicious/noExplicitAny: Needed for handling of adhoc data
        e.isSilenced = true;
    }
    return e;
};
export const isSilenced = (err) => {
    if (!err || typeof err !== "object")
        return false;
    // biome-ignore lint/suspicious/noExplicitAny: Needed for handling of adhoc data
    const e = err;
    if (e.isSilenced != null)
        return !!e.isSilenced;
    if (e.cause)
        return isSilenced(e.cause);
    return false;
};
export const captureErr = (thunk) => {
    try {
        const result = thunk();
        return { result, error: null };
    }
    catch (error) {
        return { error, result: null };
    }
};
export const captureErrAsync = async (thunk) => {
    try {
        const result = await thunk();
        return { result, error: null };
    }
    catch (error) {
        return { error, result: null };
    }
};
//# sourceMappingURL=error.js.map